import { render } from "./backgroundVideo.vue?vue&type=template&id=329db82c"
import script from "./backgroundVideo.vue?vue&type=script&lang=js"
export * from "./backgroundVideo.vue?vue&type=script&lang=js"

import "./backgroundVideo.vue?vue&type=style&index=0&id=329db82c&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__